


/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  



// Faq accordians on product page
$(document).ready(function(){
  $('.faq-title').on('click', function(){
    if($(this).hasClass('open')){
      $('.faq-info').slideUp();
      $('.faq-title').removeClass('open');
      $(this).removeClass('open').next().slideUp();
    }else{
    	$('.faq-info').slideUp();
      $('.faq-title').removeClass('open');
      	$(this).addClass('open').next().slideDown();
    }
    
  });
  
//   Bundle Products Position after product tabs on product page
  setTimeout(function() { 
          $('.Product__Aside').append($('.cbb-frequently-bought-container'));
  }, 5000);
  
  if($(window).width() < 768){    
    //   Anouncement bar slider
    $('.AnnouncementBar__Wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      // arrows: false,
      autoplay: true,
      loop: true
    });
  }
  
//   Ingredients page card rotation
  $('.ingredient-card__inner').on('click', function(){
    $(this).toggleClass('inner');
  });

});

document.addEventListener("DOMContentLoaded", function () {
 
    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "#fff";
    overlay.style.zIndex = "9999";
    document.body.appendChild(overlay);

    
    setTimeout(() => {
      overlay.remove();
    }, 10000); 
  });

// announcement bar   

$('.slider1').slick({
  dots: false,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  speed: 1000,
  slide: 'div',
   // prevArrow: '<button class="slide-arrow prev-arrow"></button>',
   //  nextArrow: '<button class="slide-arrow next-arrow"></button>',
  fade: true,
  lazyLoad: 'ondemand',
  cssEase: 'linear'
});


 var chnge = $(".Linklist__Item a")
 chnge.each(function(e) {
   if($(this).text().includes("curly kids line")){
	 $(this).addClass(' className');
//      $(this).css("color","#50aea0");
   }

//  var chnge = $(".Linklist__Item a")
//  chnge.each(function(e) {
//    if($(this).text().includes("curly kids line")){
// 	 $(this).addClass(' className');
// //      $(this).css("color","#50aea0");
//    }
 });


// $(document).ready(function() {
//   $('nav.Header__MainNav li.HorizontalList__Item > a.u-h6').each(function() {
//     var txt = $(this).text();
//     if (txt.indexOf('new arrivals')) {
//       $(this).addClass(' autumn-sale');
//     } 
//   });
// });

$(document).ready(function() {

console.clear();

$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('new') > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#EFBCC1");
      console.log("True");
}
});
$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("suhoor deal") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#EFBCC1");
      console.log("True");
}
});

$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("eid bundles") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#EFBCC1");
      console.log("True");
}
});




$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('sale') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});

$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('EID SALE') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});

$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('summer edit') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});
$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('fall edit') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});

$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('25% off') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});

$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('daily deals') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});


$('a.u-h6').each(function() {
    var txt = $(this).text();
      if (txt.indexOf('anti-dandruff ') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});


$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('glossy') > -1) {
      // $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});

$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('matcha bundles') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});

$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('summer edit') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});

$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('fall edit') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});
$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('25% off') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});

$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("suhoor deal") > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});
$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("eid bundles 25% off") > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});

$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('matcha') > -1) {
      $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("mTrue");
}
});

$('.MegaMenu ul.Linklist li a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('curl resolution bundle') > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});

$('ul.Linklist li.Linklist__Item a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('curl resolution bundle') > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});
  

$('ul.Linklist li.Linklist__Item a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('glossy') > -1) {
      // $(this).addClass(' b-friday1');
      // $(this).css("color", "#da9693");
      console.log("True");
}
});



$('a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('gift box') > -1) {
      $(this).css("color", "#1b6046");
      $(this).addClass(' gb b-friday');
      console.log("True");
}
});
$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("all men's products") > -1) {
      // $(this).addClass(' mens');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("sale") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("anti-dandruff ") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("gift box") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("Men") > -1) {
      // $(this).addClass(' mens mm');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});


$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("skin care") > -1) {
      // $(this).addClass(' mens');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("beard") > -1) {
      // $(this).addClass(' mens mm');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("beard bundle") > -1) {
      // $(this).removeClass('mm');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});



// Mob New yearsale
$('ul.Linklist li.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("beard") > -1) {
      // $(this).addClass(' mens mm');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist li.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("anti-dandruff ") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist li.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
      if (txt.indexOf("Men") > -1) {
      // $(this).addClass(' mens mm');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist li.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
      if (txt.indexOf("all men's product") > -1) {
      // $(this).addClass(' mens');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist li.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
      if (txt.indexOf("skin care") > -1) {
      // $(this).addClass(' mens');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});

$('ul.Linklist li.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
      if (txt.indexOf("beard bundle") > -1) {
      $(this).removeClass('sc');
      // $(this).css("color", "#76926d !important");
      console.log("True");
}
});
  
  
// $('.Collapsible a.u-h6').each(function() {
//     var txt = $(this).text();
//     if (txt.indexOf('sale') > -1) {
//       $(this).addClass(' b-friday');
//       //$(this).css("color", "rgb(255, 205, 145) !important");
//       console.log("True");
// }
// });

$('.Collapsible a.u-h6').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("new year's sale") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#EFBCC1");
      console.log("True");
}
});

$('ul.Linklist .Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("holiday bundles") > -1) {
      $(this).addClass(' b-friday ltd');
      // $(this).css("color", "#357a38");
      console.log("True");
}
});

// New year sale Start
$('.Linklist__Item a.Link--primary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('sale') > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#E3C565");
      console.log("True");
}
});


$('.Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("new year's sale") > -1) {
      $(this).addClass(' b-friday');
      // $(this).css("color", "#357a38");
      console.log("True");
}
});

$('.Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("holiday bundles") > -1) {
      $(this).addClass(' b-friday ltd');
      // $(this).css("color", "#357a38");
      console.log("True");
}
});
  
// New Years Ends
  
$('.Linklist__Item a.Link--secondary').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('autumn sale') > -1) {
      $(this).addClass(' autumn-sale');
      // $(this).css("color", "#357a38");
      console.log("True");
}
});

$('.Linklist--bordered .Linklist__Item a').each(function() {
    var txt = $(this).text();
    if (txt.indexOf('autumn sale') > -1) {
      $(this).addClass(' autumn-sale');
      // $(this).css("color", "#ec6816");
      console.log("True");
}
});


// limited products
$('.ProductMeta>h1').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("Kids Basic Bundle") > -1) {
      $(this).addClass(' kids-basics');
      $(this).append(" <span class='kidss-a'>limited time</span>");
      //$(this).css("color", "#357a38");
      console.log("True");
}
});

$('.ProductMeta>h1').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("Kids Scalp Care Bundle") > -1) {
      $(this).addClass(' kids-basics');
      $(this).append(" <span class='kidss-a'>limited time</span>");
      //$(this).css("color", "#357a38");
      console.log("True");
}
});

$('.ProductMeta>h1').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("Scalp Care Bundle") > -1) {
      $(this).addClass(' kids-basics');
      $(this).append(" <span class='kidss-a'>limited time</span>");
      //$(this).css("color", "#357a38");
      console.log("True");
}
});

$('.ProductMeta>h1').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("Styling Bundle") > -1) {
      $(this).addClass(' kids-basics');
      $(this).append(" <span class='kidss-a'>limited time</span>");
      //$(this).css("color", "#357a38");
      console.log("True");
}
});

$('.ProductMeta>h1').each(function() {
    var txt = $(this).text();
    if (txt.indexOf("The Accessories Bundle") > -1) {
      $(this).addClass(' kids-basics');
      $(this).append(" <span class='kidss-a'>limited time</span>");
      //$(this).css("color", "#357a38");
      console.log("True");
}
});



//limited product ends 
var chnge1 = $(".Linklist__Item a")
 chnge.each(function(e) {
   if($(this).text().includes("strength")){
	 $(this).addClass(' strength-lines');
//      $(this).css("color","#50aea0");
   }
 })

  
// // pakistan remove
//   var element = $(".Collapsible__Button");
//   element.text(element.text().replace("pakistan", ""));


// Community page


    $(document).ready(function () {
        var el = $('.owl-carousel');

        var carousel;
        var carouselOptions = {
            margin: 20,
            nav: true,
            autoplay: true,
            dots: false,
            slideBy: 'page',
            responsive: {
                0: {
                    items: 1,
                    rows: 2 //custom option not used by Owl Carousel, but used by the algorithm below
                },
                768: {
                    items: 2,
                    rows: 3 //custom option not used by Owl Carousel, but used by the algorithm below
                },
                991: {
                    items: 3,
                    rows: 2 //custom option not used by Owl Carousel, but used by the algorithm below
                }
            }
        };

        //Taken from Owl Carousel so we calculate width the same way
        var viewport = function () {
            var width;
            if (carouselOptions.responsiveBaseElement && carouselOptions.responsiveBaseElement !== window) {
                width = $(carouselOptions.responsiveBaseElement).width();
            } else if (window.innerWidth) {
                width = window.innerWidth;
            } else if (document.documentElement && document.documentElement.clientWidth) {
                width = document.documentElement.clientWidth;
            } else {
                console.warn('Can not detect viewport width.');
            }
            return width;
        };

        var severalRows = false;
        var orderedBreakpoints = [];
        for (var breakpoint in carouselOptions.responsive) {
            if (carouselOptions.responsive[breakpoint].rows > 1) {
                severalRows = true;
            }
            orderedBreakpoints.push(parseInt(breakpoint));
        }

        //Custom logic is active if carousel is set up to have more than one row for some given window width
        if (severalRows) {
            orderedBreakpoints.sort(function (a, b) {
                return b - a;
            });
            var slides = el.find('[data-slide-index]');
            var slidesNb = slides.length;
            if (slidesNb > 0) {
                var rowsNb;
                var previousRowsNb = undefined;
                var colsNb;
                var previousColsNb = undefined;

                //Calculates number of rows and cols based on current window width
                var updateRowsColsNb = function () {
                    var width = viewport();
                    for (var i = 0; i < orderedBreakpoints.length; i++) {
                        var breakpoint = orderedBreakpoints[i];
                        if (width >= breakpoint || i == (orderedBreakpoints.length - 1)) {
                            var breakpointSettings = carouselOptions.responsive['' + breakpoint];
                            rowsNb = breakpointSettings.rows;
                            colsNb = breakpointSettings.items;
                            break;
                        }
                    }
                };

                var updateCarousel = function () {
                    updateRowsColsNb();

                    //Carousel is recalculated if and only if a change in number of columns/rows is requested
                    if (rowsNb != previousRowsNb || colsNb != previousColsNb) {
                        var reInit = false;
                        if (carousel) {
                            //Destroy existing carousel if any, and set html markup back to its initial state
                            carousel.trigger('destroy.owl.carousel');
                            carousel = undefined;
                            slides = el.find('[data-slide-index]').detach().appendTo(el);
                            el.find('.fake-col-wrapper').remove();
                            reInit = true;
                        }


                        //This is the only real 'smart' part of the algorithm

                        //First calculate the number of needed columns for the whole carousel
                        var perPage = rowsNb * colsNb;
                        var pageIndex = Math.floor(slidesNb / perPage);
                        var fakeColsNb = pageIndex * colsNb + (slidesNb >= (pageIndex * perPage + colsNb) ? colsNb : (slidesNb % colsNb));

                        //Then populate with needed html markup
                        var count = 0;
                        for (var i = 0; i < fakeColsNb; i++) {
                            //For each column, create a new wrapper div
                            var fakeCol = $('<div class="fake-col-wrapper"></div>').appendTo(el);
                            for (var j = 0; j < rowsNb; j++) {
                                //For each row in said column, calculate which slide should be present
                                var index = Math.floor(count / perPage) * perPage + (i % colsNb) + j * colsNb;
                                if (index < slidesNb) {
                                    //If said slide exists, move it under wrapper div
                                    slides.filter('[data-slide-index=' + index + ']').detach().appendTo(fakeCol);
                                }
                                count++;
                            }
                        }
                        //end of 'smart' part

                        previousRowsNb = rowsNb;
                        previousColsNb = colsNb;

                        if (reInit) {
                            //re-init carousel with new markup
                            carousel = el.owlCarousel(carouselOptions);
                        }
                    }
                };

                //Trigger possible update when window size changes
                $(window).on('resize', updateCarousel);

                //We need to execute the algorithm once before first init in any case
                updateCarousel();
            }
        }

        //init
        carousel = el.owlCarousel(carouselOptions);
    });

// Community Page

  
 });

jQuery(document).ready(function($){
    var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.cd-image-container');
    //check if the .cd-image-container is in the viewport 
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on('scroll', function(){
        if( !scrolling) {
            scrolling =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
        }
    });
    
    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    $(window).on('resize', function(){
        if( !resizing) {
            resizing =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
        }
    });

    function checkPosition(container) {
        container.each(function(){
            var actualContainer = $(this);
            if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
                actualContainer.addClass('is-visible');
            }
        });

        scrolling = false;
    }

    function checkLabel(container) {
        container.each(function(){
            var actual = $(this);
            updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
            updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
        });

        resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
        dragElement.on("mousedown vmousedown", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - e.pageX,
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 0,
                maxLeft = containerOffset + containerWidth - dragWidth - 0;
            
            dragElement.parents().on("mousemove vmousemove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
                }
            }).on("mouseup vmouseup", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup vmouseup", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
        var leftValue = e.pageX + xPosition - dragWidth;   
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
        
        $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        updateLabel(labelResizeElement, resizeElement, 'left');
        updateLabel(labelContainer, resizeElement, 'right');
        dragging =  false;
    }

    function updateLabel(label, resizeElement, position) {
        if(position == 'left') {
            ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        } else {
            ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        }
    }
});

